{
  "languages": {
    "ascl-code.gaelic_scotland": "Gaelic (Scotland)",
    "ascl-code.irish": "Irish",
    "ascl-code.welsh": "Welsh",
    "ascl-code.celtic_nec": "Celtic, nec",
    "ascl-code.english": "English",
    "ascl-code.german": "German",
    "ascl-code.letzeburgish": "Letzeburgish",
    "ascl-code.yiddish": "Yiddish",
    "ascl-code.dutch": "Dutch",
    "ascl-code.frisian": "Frisian",
    "ascl-code.afrikaans": "Afrikaans",
    "ascl-code.danish": "Danish",
    "ascl-code.icelandic": "Icelandic",
    "ascl-code.norwegian": "Norwegian",
    "ascl-code.swedish": "Swedish",
    "ascl-code.scandinavian_nec": "Scandinavian, nec",
    "ascl-code.estonian": "Estonian",
    "ascl-code.finnish": "Finnish",
    "ascl-code.finnish_and_related_languages_nec": "Finnish and Related Languages, nec",
    "ascl-code.french": "French",
    "ascl-code.greek": "Greek",
    "ascl-code.catalan": "Catalan",
    "ascl-code.portuguese": "Portuguese",
    "ascl-code.spanish": "Spanish",
    "ascl-code.iberian_romance_nec": "Iberian Romance, nec",
    "ascl-code.italian": "Italian",
    "ascl-code.maltese": "Maltese",
    "ascl-code.basque": "Basque",
    "ascl-code.latin": "Latin",
    "ascl-code.other_southern_european_languages_nec": "Other Southern European Languages, nec",
    "ascl-code.latvian": "Latvian",
    "ascl-code.lithuanian": "Lithuanian",
    "ascl-code.hungarian": "Hungarian",
    "ascl-code.belorussian": "Belorussian",
    "ascl-code.russian": "Russian",
    "ascl-code.ukrainian": "Ukrainian",
    "ascl-code.bosnian": "Bosnian",
    "ascl-code.bulgarian": "Bulgarian",
    "ascl-code.croatian": "Croatian",
    "ascl-code.macedonian": "Macedonian",
    "ascl-code.serbian": "Serbian",
    "ascl-code.slovene": "Slovene",
    "ascl-code.serbo-croatian_yugoslavian_so_described": "Serbo-Croatian/Yugoslavian, so described",
    "ascl-code.czech": "Czech",
    "ascl-code.polish": "Polish",
    "ascl-code.slovak": "Slovak",
    "ascl-code.czechoslovakian_so_described": "Czechoslovakian, so described",
    "ascl-code.albanian": "Albanian",
    "ascl-code.aromunian_macedo-romanian": "Aromunian (Macedo-Romanian)",
    "ascl-code.romanian": "Romanian",
    "ascl-code.romany": "Romany",
    "ascl-code.other_eastern_european_languages_nec": "Other Eastern European Languages, nec",
    "ascl-code.kurdish": "Kurdish",
    "ascl-code.pashto": "Pashto",
    "ascl-code.balochi": "Balochi",
    "ascl-code.dari": "Dari",
    "ascl-code.persian_excluding_dari": "Persian (excluding Dari)",
    "ascl-code.hazaraghi": "Hazaraghi",
    "ascl-code.iranic_nec": "Iranic, nec",
    "ascl-code.arabic": "Arabic",
    "ascl-code.hebrew": "Hebrew",
    "ascl-code.assyrian_neo-aramaic": "Assyrian Neo-Aramaic",
    "ascl-code.chaldean_neo-aramaic": "Chaldean Neo-Aramaic",
    "ascl-code.mandaean_mandaic": "Mandaean (Mandaic)",
    "ascl-code.middle_eastern_semitic_languages_nec": "Middle Eastern Semitic Languages, nec",
    "ascl-code.turkish": "Turkish",
    "ascl-code.azeri": "Azeri",
    "ascl-code.tatar": "Tatar",
    "ascl-code.turkmen": "Turkmen",
    "ascl-code.uygur": "Uygur",
    "ascl-code.uzbek": "Uzbek",
    "ascl-code.turkic_nec": "Turkic, nec",
    "ascl-code.armenian": "Armenian",
    "ascl-code.georgian": "Georgian",
    "ascl-code.other_southwest_and_central_asian_languages_nec": "Other Southwest and Central Asian Languages, nec",
    "ascl-code.kannada": "Kannada",
    "ascl-code.malayalam": "Malayalam",
    "ascl-code.tamil": "Tamil",
    "ascl-code.telugu": "Telugu",
    "ascl-code.tulu": "Tulu",
    "ascl-code.dravidian_nec": "Dravidian, nec",
    "ascl-code.bengali": "Bengali",
    "ascl-code.gujarati": "Gujarati",
    "ascl-code.hindi": "Hindi",
    "ascl-code.konkani": "Konkani",
    "ascl-code.marathi": "Marathi",
    "ascl-code.nepali": "Nepali",
    "ascl-code.punjabi": "Punjabi",
    "ascl-code.sindhi": "Sindhi",
    "ascl-code.sinhalese": "Sinhalese",
    "ascl-code.urdu": "Urdu",
    "ascl-code.assamese": "Assamese",
    "ascl-code.dhivehi": "Dhivehi",
    "ascl-code.kashmiri": "Kashmiri",
    "ascl-code.oriya": "Oriya",
    "ascl-code.fijian_hindustani": "Fijian Hindustani",
    "ascl-code.indo-aryan_nec": "Indo-Aryan, nec",
    "ascl-code.other_southern_asian_languages": "Other Southern Asian Languages",
    "ascl-code.burmese": "Burmese",
    "ascl-code.chin_haka": "Chin Haka",
    "ascl-code.karen": "Karen",
    "ascl-code.rohingya": "Rohingya",
    "ascl-code.zomi": "Zomi",
    "ascl-code.burmese_and_related_languages_nec": "Burmese and Related Languages, nec",
    "ascl-code.hmong": "Hmong",
    "ascl-code.hmong-mien_nec": "Hmong-Mien, nec",
    "ascl-code.khmer": "Khmer",
    "ascl-code.vietnamese": "Vietnamese",
    "ascl-code.mon": "Mon",
    "ascl-code.mon-khmer_nec": "Mon-Khmer, nec",
    "ascl-code.lao": "Lao",
    "ascl-code.thai": "Thai",
    "ascl-code.tai_nec": "Tai, nec",
    "ascl-code.bisaya": "Bisaya",
    "ascl-code.cebuano": "Cebuano",
    "ascl-code.iiokano": "IIokano",
    "ascl-code.indonesian": "Indonesian",
    "ascl-code.malay": "Malay",
    "ascl-code.tetum": "Tetum",
    "ascl-code.timorese": "Timorese",
    "ascl-code.tagalog": "Tagalog",
    "ascl-code.filipino": "Filipino",
    "ascl-code.acehnese": "Acehnese",
    "ascl-code.balinese": "Balinese",
    "ascl-code.bikol": "Bikol",
    "ascl-code.iban": "Iban",
    "ascl-code.ilonggo_hiligaynon": "Ilonggo (Hiligaynon)",
    "ascl-code.javanese": "Javanese",
    "ascl-code.pampangan": "Pampangan",
    "ascl-code.southeast_asian_austronesian_languages_nec": "Southeast Asian Austronesian Languages, nec",
    "ascl-code.other_southeast_asian_languages": "Other Southeast Asian Languages",
    "ascl-code.cantonese": "Cantonese",
    "ascl-code.hakka": "Hakka",
    "ascl-code.mandarin": "Mandarin",
    "ascl-code.wu": "Wu",
    "ascl-code.min_nan": "Min Nan",
    "ascl-code.chinese_nec": "Chinese, nec",
    "ascl-code.japanese": "Japanese",
    "ascl-code.korean": "Korean",
    "ascl-code.tibetan": "Tibetan",
    "ascl-code.mongolian": "Mongolian",
    "ascl-code.other_eastern_asian_languages_nec": "Other Eastern Asian Languages, nec",
    "ascl-code.anindilyakwa": "Anindilyakwa",
    "ascl-code.maung": "Maung",
    "ascl-code.ngan_gikurunggurr": "Ngan'gikurunggurr",
    "ascl-code.nunggubuyu": "Nunggubuyu",
    "ascl-code.rembarrnga": "Rembarrnga",
    "ascl-code.tiwi": "Tiwi",
    "ascl-code.alawa": "Alawa",
    "ascl-code.dalabon": "Dalabon",
    "ascl-code.gudanji": "Gudanji",
    "ascl-code.iwaidja": "Iwaidja",
    "ascl-code.jaminjung": "Jaminjung",
    "ascl-code.jawoyn": "Jawoyn",
    "ascl-code.jingulu": "Jingulu",
    "ascl-code.kunbarlang": "Kunbarlang",
    "ascl-code.larrakiya": "Larrakiya",
    "ascl-code.malak_malak": "Malak Malak",
    "ascl-code.mangarrayi": "Mangarrayi",
    "ascl-code.maringarr": "Maringarr",
    "ascl-code.marra": "Marra",
    "ascl-code.marrithiyel": "Marrithiyel",
    "ascl-code.matngala": "Matngala",
    "ascl-code.murrinh_patha": "Murrinh Patha",
    "ascl-code.na-kara": "Na-kara",
    "ascl-code.ndjebbana_gunavidji": "Ndjebbana (Gunavidji)",
    "ascl-code.ngalakgan": "Ngalakgan",
    "ascl-code.ngaliwurru": "Ngaliwurru",
    "ascl-code.nungali": "Nungali",
    "ascl-code.wambaya": "Wambaya",
    "ascl-code.wardaman": "Wardaman",
    "ascl-code.amurdak": "Amurdak",
    "ascl-code.garrwa": "Garrwa",
    "ascl-code.kuwema": "Kuwema",
    "ascl-code.marramaninyshi": "Marramaninyshi",
    "ascl-code.ngandi": "Ngandi",
    "ascl-code.waanyi": "Waanyi",
    "ascl-code.wagiman": "Wagiman",
    "ascl-code.yanyuwa": "Yanyuwa",
    "ascl-code.marridan_maridan": "Marridan (Maridan)",
    "ascl-code.gundjeihmi": "Gundjeihmi",
    "ascl-code.kune": "Kune",
    "ascl-code.kuninjku": "Kuninjku",
    "ascl-code.kunwinjku": "Kunwinjku",
    "ascl-code.mayali": "Mayali",
    "ascl-code.kunwinjkuan_nec": "Kunwinjkuan, nec",
    "ascl-code.burarra": "Burarra",
    "ascl-code.gun-nartpa": "Gun-nartpa",
    "ascl-code.gurr-goni": "Gurr-goni",
    "ascl-code.burarran_nec": "Burarran, nec",
    "ascl-code.arnhem_land_and_daly_river_region_languages_nec": "Arnhem Land and Daly River Region Languages, nec",
    "ascl-code.galpu": "Galpu",
    "ascl-code.golumala": "Golumala",
    "ascl-code.wangurri": "Wangurri",
    "ascl-code.dhangu_nec": "Dhangu, nec",
    "ascl-code.dhalwangu": "Dhalwangu",
    "ascl-code.djarrwark": "Djarrwark",
    "ascl-code.dhay_yi_nec": "Dhay'yi, nec",
    "ascl-code.djambarrpuyngu": "Djambarrpuyngu",
    "ascl-code.djapu": "Djapu",
    "ascl-code.daatiwuy": "Daatiwuy",
    "ascl-code.marrangu": "Marrangu",
    "ascl-code.liyagalawumirr": "Liyagalawumirr",
    "ascl-code.liyagawumirr": "Liyagawumirr",
    "ascl-code.dhuwal_nec": "Dhuwal, nec",
    "ascl-code.gumatj": "Gumatj",
    "ascl-code.gupapuyngu": "Gupapuyngu",
    "ascl-code.guyamirrilili": "Guyamirrilili",
    "ascl-code.manggalili": "Manggalili",
    "ascl-code.wubulkarra": "Wubulkarra",
    "ascl-code.dhuwala_nec": "Dhuwala, nec",
    "ascl-code.wurlaki": "Wurlaki",
    "ascl-code.djinang_nec": "Djinang, nec",
    "ascl-code.ganalbingu": "Ganalbingu",
    "ascl-code.djinba": "Djinba",
    "ascl-code.manyjalpingu": "Manyjalpingu",
    "ascl-code.djinba_nec": "Djinba, nec",
    "ascl-code.ritharrngu": "Ritharrngu",
    "ascl-code.wagilak": "Wagilak",
    "ascl-code.yakuy_nec": "Yakuy, nec",
    "ascl-code.nhangu": "Nhangu",
    "ascl-code.yan-nhangu": "Yan-nhangu",
    "ascl-code.nhangu_nec": "Nhangu, nec",
    "ascl-code.dhuwaya": "Dhuwaya",
    "ascl-code.djangu": "Djangu",
    "ascl-code.madarrpa": "Madarrpa",
    "ascl-code.warramiri": "Warramiri",
    "ascl-code.rirratjingu": "Rirratjingu",
    "ascl-code.other_yolngu_matha_nec": "Other Yolngu Matha, nec",
    "ascl-code.kuku_yalanji": "Kuku Yalanji",
    "ascl-code.guugu_yimidhirr": "Guugu Yimidhirr",
    "ascl-code.kuuku-ya_u": "Kuuku-Ya'u",
    "ascl-code.wik_mungkan": "Wik Mungkan",
    "ascl-code.djabugay": "Djabugay",
    "ascl-code.dyirbal": "Dyirbal",
    "ascl-code.girramay": "Girramay",
    "ascl-code.koko-bera": "Koko-Bera",
    "ascl-code.kuuk_thayorre": "Kuuk Thayorre",
    "ascl-code.lamalama": "Lamalama",
    "ascl-code.yidiny": "Yidiny",
    "ascl-code.wik_ngathan": "Wik Ngathan",
    "ascl-code.alngith": "Alngith",
    "ascl-code.kugu_muminh": "Kugu Muminh",
    "ascl-code.morrobalama": "Morrobalama",
    "ascl-code.thaynakwith": "Thaynakwith",
    "ascl-code.yupangathi": "Yupangathi",
    "ascl-code.tjungundji": "Tjungundji",
    "ascl-code.cape_york_peninsula_languages_nec": "Cape York Peninsula Languages, nec",
    "ascl-code.kalaw_kawaw_ya_kalaw_lagaw_ya": "Kalaw Kawaw Ya/Kalaw Lagaw Ya",
    "ascl-code.meriam_mir": "Meriam Mir",
    "ascl-code.yumplatok_torres_strait_creole": "Yumplatok (Torres Strait Creole)",
    "ascl-code.bilinarra": "Bilinarra",
    "ascl-code.gurindji": "Gurindji",
    "ascl-code.gurindji_kriol": "Gurindji Kriol",
    "ascl-code.jaru": "Jaru",
    "ascl-code.light_warlpiri": "Light Warlpiri",
    "ascl-code.malngin": "Malngin",
    "ascl-code.mudburra": "Mudburra",
    "ascl-code.ngardi": "Ngardi",
    "ascl-code.ngarinyman": "Ngarinyman",
    "ascl-code.walmajarri": "Walmajarri",
    "ascl-code.wanyjirra": "Wanyjirra",
    "ascl-code.warlmanpa": "Warlmanpa",
    "ascl-code.warlpiri": "Warlpiri",
    "ascl-code.warumungu": "Warumungu",
    "ascl-code.northern_desert_fringe_area_languages_nec": "Northern Desert Fringe Area Languages, nec",
    "ascl-code.alyawarr": "Alyawarr",
    "ascl-code.kaytetye": "Kaytetye",
    "ascl-code.antekerrepenh": "Antekerrepenh",
    "ascl-code.central_anmatyerr": "Central Anmatyerr",
    "ascl-code.eastern_anmatyerr": "Eastern Anmatyerr",
    "ascl-code.anmatyerr_nec": "Anmatyerr, nec",
    "ascl-code.eastern_arrernte": "Eastern Arrernte",
    "ascl-code.western_arrarnta": "Western Arrarnta",
    "ascl-code.arrernte_nec": "Arrernte, nec",
    "ascl-code.arandic_nec": "Arandic, nec",
    "ascl-code.antikarinya": "Antikarinya",
    "ascl-code.kartujarra": "Kartujarra",
    "ascl-code.kukatha": "Kukatha",
    "ascl-code.kukatja": "Kukatja",
    "ascl-code.luritja": "Luritja",
    "ascl-code.manyjilyjarra": "Manyjilyjarra",
    "ascl-code.martu_wangka": "Martu Wangka",
    "ascl-code.ngaanyatjarra": "Ngaanyatjarra",
    "ascl-code.pintupi": "Pintupi",
    "ascl-code.pitjantjatjara": "Pitjantjatjara",
    "ascl-code.wangkajunga": "Wangkajunga",
    "ascl-code.wangkatha": "Wangkatha",
    "ascl-code.warnman": "Warnman",
    "ascl-code.yankunytjatjara": "Yankunytjatjara",
    "ascl-code.yulparija": "Yulparija",
    "ascl-code.tjupany": "Tjupany",
    "ascl-code.western_desert_languages_nec": "Western Desert Languages, nec",
    "ascl-code.bardi": "Bardi",
    "ascl-code.bunuba": "Bunuba",
    "ascl-code.gooniyandi": "Gooniyandi",
    "ascl-code.miriwoong": "Miriwoong",
    "ascl-code.ngarinyin": "Ngarinyin",
    "ascl-code.nyikina": "Nyikina",
    "ascl-code.worla": "Worla",
    "ascl-code.worrorra": "Worrorra",
    "ascl-code.wunambal": "Wunambal",
    "ascl-code.yawuru": "Yawuru",
    "ascl-code.gambera": "Gambera",
    "ascl-code.jawi": "Jawi",
    "ascl-code.kija": "Kija",
    "ascl-code.kimberley_area_languages_nec": "Kimberley Area Languages, nec",
    "ascl-code.adnymathanha": "Adnymathanha",
    "ascl-code.arabana": "Arabana",
    "ascl-code.bandjalang": "Bandjalang",
    "ascl-code.banyjima": "Banyjima",
    "ascl-code.batjala": "Batjala",
    "ascl-code.bidjara": "Bidjara",
    "ascl-code.dhanggatti": "Dhanggatti",
    "ascl-code.diyari": "Diyari",
    "ascl-code.gamilaraay": "Gamilaraay",
    "ascl-code.garuwali": "Garuwali",
    "ascl-code.githabul": "Githabul",
    "ascl-code.gumbaynggir": "Gumbaynggir",
    "ascl-code.kanai": "Kanai",
    "ascl-code.karajarri": "Karajarri",
    "ascl-code.kariyarra": "Kariyarra",
    "ascl-code.kaurna": "Kaurna",
    "ascl-code.kayardild": "Kayardild",
    "ascl-code.kriol": "Kriol",
    "ascl-code.lardil": "Lardil",
    "ascl-code.mangala": "Mangala",
    "ascl-code.muruwari": "Muruwari",
    "ascl-code.narungga": "Narungga",
    "ascl-code.ngarluma": "Ngarluma",
    "ascl-code.ngarrindjeri": "Ngarrindjeri",
    "ascl-code.nyamal": "Nyamal",
    "ascl-code.nyangumarta": "Nyangumarta",
    "ascl-code.nyungar": "Nyungar",
    "ascl-code.paakantyi": "Paakantyi",
    "ascl-code.palyku_nyiyaparli": "Palyku/Nyiyaparli",
    "ascl-code.wajarri": "Wajarri",
    "ascl-code.wiradjuri": "Wiradjuri",
    "ascl-code.yindjibarndi": "Yindjibarndi",
    "ascl-code.yinhawangka": "Yinhawangka",
    "ascl-code.yorta_yorta": "Yorta Yorta",
    "ascl-code.baanbay": "Baanbay",
    "ascl-code.badimaya": "Badimaya",
    "ascl-code.barababaraba": "Barababaraba",
    "ascl-code.dadi_dadi": "Dadi Dadi",
    "ascl-code.dharawal": "Dharawal",
    "ascl-code.djabwurrung": "Djabwurrung",
    "ascl-code.gudjal": "Gudjal",
    "ascl-code.keerray-woorroong": "Keerray-Woorroong",
    "ascl-code.ladji_ladji": "Ladji Ladji",
    "ascl-code.mirning": "Mirning",
    "ascl-code.ngatjumaya": "Ngatjumaya",
    "ascl-code.waluwarra": "Waluwarra",
    "ascl-code.wangkangurru": "Wangkangurru",
    "ascl-code.wargamay": "Wargamay",
    "ascl-code.wergaia": "Wergaia",
    "ascl-code.yugambeh": "Yugambeh",
    "ascl-code.aboriginal_english_so_described": "Aboriginal English, so described",
    "ascl-code.other_australian_indigenous_languages_nec": "Other Australian Indigenous Languages, nec",
    "ascl-code.american_languages": "American Languages",
    "ascl-code.acholi": "Acholi",
    "ascl-code.akan": "Akan",
    "ascl-code.mauritian_creole": "Mauritian Creole",
    "ascl-code.oromo": "Oromo",
    "ascl-code.shona": "Shona",
    "ascl-code.somali": "Somali",
    "ascl-code.swahili": "Swahili",
    "ascl-code.yoruba": "Yoruba",
    "ascl-code.zulu": "Zulu",
    "ascl-code.amharic": "Amharic",
    "ascl-code.bemba": "Bemba",
    "ascl-code.dinka": "Dinka",
    "ascl-code.ewe": "Ewe",
    "ascl-code.ga": "Ga",
    "ascl-code.harari": "Harari",
    "ascl-code.hausa": "Hausa",
    "ascl-code.igbo": "Igbo",
    "ascl-code.kikuyu": "Kikuyu",
    "ascl-code.krio": "Krio",
    "ascl-code.luganda": "Luganda",
    "ascl-code.luo": "Luo",
    "ascl-code.ndebele": "Ndebele",
    "ascl-code.nuer": "Nuer",
    "ascl-code.nyanja_chichewa": "Nyanja (Chichewa)",
    "ascl-code.shilluk": "Shilluk",
    "ascl-code.tigre": "Tigre",
    "ascl-code.tigrinya": "Tigrinya",
    "ascl-code.tswana": "Tswana",
    "ascl-code.xhosa": "Xhosa",
    "ascl-code.seychelles_creole": "Seychelles Creole",
    "ascl-code.anuak": "Anuak",
    "ascl-code.bari": "Bari",
    "ascl-code.bassa": "Bassa",
    "ascl-code.dan_gio-dan": "Dan (Gio-Dan)",
    "ascl-code.fulfulde": "Fulfulde",
    "ascl-code.kinyarwanda_rwanda": "Kinyarwanda (Rwanda)",
    "ascl-code.kirundi_rundi": "Kirundi (Rundi)",
    "ascl-code.kpelle": "Kpelle",
    "ascl-code.krahn": "Krahn",
    "ascl-code.liberian_liberian_english": "Liberian (Liberian English)",
    "ascl-code.loma_lorma": "Loma (Lorma)",
    "ascl-code.lumun_kuku_lumun": "Lumun (Kuku Lumun)",
    "ascl-code.madi": "Madi",
    "ascl-code.mandinka": "Mandinka",
    "ascl-code.mann": "Mann",
    "ascl-code.moro_nuba_moro": "Moro (Nuba Moro)",
    "ascl-code.themne": "Themne",
    "ascl-code.lingala": "Lingala",
    "ascl-code.african_languages_nec": "African Languages, nec",
    "ascl-code.fijian": "Fijian",
    "ascl-code.gilbertese": "Gilbertese",
    "ascl-code.maori_cook_island": "Maori (Cook Island)",
    "ascl-code.maori_new_zealand": "Maori (New Zealand)",
    "ascl-code.nauruan": "Nauruan",
    "ascl-code.niue": "Niue",
    "ascl-code.samoan": "Samoan",
    "ascl-code.tongan": "Tongan",
    "ascl-code.rotuman": "Rotuman",
    "ascl-code.tokelauan": "Tokelauan",
    "ascl-code.tuvaluan": "Tuvaluan",
    "ascl-code.yapese": "Yapese",
    "ascl-code.pacific_austronesian_languages_nec": "Pacific Austronesian Languages, nec",
    "ascl-code.bislama": "Bislama",
    "ascl-code.hawaiian_english": "Hawaiian English",
    "ascl-code.norf_k-pitcairn": "Norf'k-Pitcairn",
    "ascl-code.solomon_islands_pijin": "Solomon Islands Pijin",
    "ascl-code.oceanian_pidgins_and_creoles_nec": "Oceanian Pidgins and Creoles, nec",
    "ascl-code.kiwai": "Kiwai",
    "ascl-code.motu_hirimotu": "Motu (HiriMotu)",
    "ascl-code.tok_pisin_neomelanesian": "Tok Pisin (Neomelanesian)",
    "ascl-code.papua_new_guinea_languages_nec": "Papua New Guinea Languages, nec",
    "ascl-code.invented_languages": "Invented Languages",
    "ascl-code.auslan": "Auslan",
    "ascl-code.key_word_sign_australia": "Key Word Sign Australia",
    "ascl-code.sign_languages_nec": "Sign Languages, nec"
  }
}
